export function getFsrRiskBand(fsr: number | undefined): "low" | "medium" | "high" | null {
	if (fsr === undefined || Number.isNaN(fsr)) {
		return null;
	}
	if (fsr >= 66) {
		return "low";
	}
	if (fsr >= 31) {
		return "medium";
	}
	return "high";
}
